import React, { Component } from 'react';
import { Row, Col, Card, Popover, Divider, Icon } from 'antd';
import Img from 'react-image';
import AfspUserAccountControls from './AfspUserAccountControls';
import AfspUserSettingsControls from './AfspUserSettingsControls';
import { ssCommonUtils, ssSessionUtils } from '@bit/ui-common.ui-components/ss-utils';

const
{ htmlStorage, logout } = ssSessionUtils,
{ setEnvPrefix } = ssCommonUtils;

export default class AfspUserControls extends Component {
    state = { modals: {
        showAccount: false,
        showSettings: false
    }}

    constructor(props) {
        super(props);
        this.handleModalView = this.handleModalView.bind(this);
    }

    handleMouse(type, e) {
        let a = e.target.parentElement;
        switch (type) {
            case 'down':
                a.style.backgroundColor = 'rgb(179, 192, 199)';
                break;
            case 'up':
                a.style.backgroundColor = '';
                break;
        }
    }

    handleModalView(modal) {
        const { modals } = this.state;
        switch (modal) {
            case 'account':
                this.setState({...this.state, modals: {...modals, showAccount: !modals.showAccount }});
                break;

            case 'settings':
                this.setState({...this.state, modals: {...modals, showSettings: !modals.showSettings }});
                break;
        }
    }

    getModals() {
        let { handleModalView } = this,
        { styles, images, menu } = this.props,
        { modals } = this.state;

        return [
            <AfspUserAccountControls key={'afsp-user-account-controls'}/>,
            <AfspUserSettingsControls key={'afsp-user-settings-controls'}/>
        ].map(v => React.cloneElement(v, {
            modals: modals,
            styles: styles,
            images: images,
            menu: menu,
            handleModalView: handleModalView
        }));
    }

    render() {
        const
        s = this.props.styles,
        { usePathname, user } = this.props.images,
        { USER_DETAILS, ROLES, LOGIN_AS } = window.session.jwtSession,
        hasProviderAdmin = ROLES.find(e => e === 'PROVIDER_ADMIN'),
        readOnly = window.session.jwtSession["read-only"] == undefined || window.session.jwtSession["read-only"] != true ? false: true,
        aProps = {
            style: {
                color: 'rgb(89, 89, 89)'
            },
            onMouseDown: e => this.handleMouse('down', e),
            onMouseUp: e => this.handleMouse('up', e)
        },
        userCardProps = {
            style: {
                padding: '5px 10px 5px 10px',
                textAlign: 'center',
                width: '100%',
                background: '#fff',
                borderRadius: '4px',
                borderStyle: 'none',
                borderWidth: '0px'
            }
        };

        var divClassName = 'afsp-account-image-card';
        if(LOGIN_AS){
          divClassName = 'afsp-admin-account-image-card';
        }

        return (
            <div>
                {this.getModals()}
                <Row style={s.row1.style}>
                    <Col span={24} style={s.row1.col1.style}>
                        <Popover
                            style={{ background: 'orange' }}
                            placement='bottomRight'
                            content={(<div
                                style={{ width: '120px', margin: '-5px -10px -5px -10px' }}>
                                <Card
                                    bodyStyle={{ padding: '14px 8px' }}
                                    style={{
                                        textAlign: 'center',
                                        width: '100%',
                                        background: '#fff',
                                        borderRadius: '4px',
                                        borderColor: 'white',
                                        borderStyle: 'solid',
                                        overflow: 'hidden',
                                        margin: '-13px 0px'
                                    }}>
                                    <div>
                                        <Img
                                            src={usePathname ? `${setEnvPrefix(window.location.pathname)}${user}` : `${user}`}
                                            style={{ width: '95px', height: '95px' }}
                                        />
                                    </div>
                                    <div>
                                        <Row type='flex' justify='space-around' align='middle'>
                                            <Col span={24}>
                                                <div>
                                                    <span style={{ fontSize: '11px', fontWeight: 'bold', fontStyle: 'italic' }}>
                                                        {`${USER_DETAILS.FIRST_NAME} ${USER_DETAILS.LAST_NAME}`}
                                                    </span>
                                                </div>
                                                {!hasProviderAdmin ? null : (
                                                    <div>
                                                        <span
                                                            style={{ fontStyle: 'italic' }}>
                                                            {'Provider Admin'}
                                                        </span>
                                                    </div>
                                                )}
                                            </Col>
                                        </Row>
                                    </div>
                                    <Divider type='horizontal' style={{ margin: '10px 0px 10px 0px' }} />
                                    <a href='#' {...aProps} onClick={() => logout()}>
                                        <Card.Grid {...{...userCardProps, style: {...userCardProps.style, borderRadius: '4px 4px 0px 0px' }}}>
                                            <div
                                                style={{
                                                    display: 'inline-block',
                                                    marginRight: '10%'
                                                }}>
                                                <Icon type='logout'/>
                                            </div>
                                            <div
                                                style={{ display: 'inline-block' }}>
                                                {'Log Out'}
                                            </div>
                                        </Card.Grid>
                                    </a>
                                    <a href='#' {...aProps} onClick={() => { if (readOnly) {e.preventDefault()} else {this.handleModalView('account')}}}>
                                        <Card.Grid {...{...userCardProps, style: {...userCardProps.style, borderRadius: '0px', backgroundColor: readOnly ? 'grey': 'none', pointerEvents: readOnly ? 'none': 'auto' }}}>
                                            <div
                                                style={{
                                                    display: 'inline-block',
                                                    marginRight: '10%'
                                                }}>
                                                <Icon type='user'/>
                                            </div>
                                            <div
                                                style={{
                                                    display: 'inline-block'
                                                }}>
                                                {'Account'}
                                            </div>
                                        </Card.Grid>
                                    </a>
                                    <a href='#' {...aProps} onClick={() => { if (readOnly) {e.preventDefault()} else this.handleModalView('settings')}}>
                                        <Card.Grid {...{...userCardProps, style: {...userCardProps.style, borderRadius: '0px 0px 4px 4px', backgroundColor: readOnly ? 'grey': 'none', pointerEvents: readOnly ? 'none': 'auto' }}}>
                                            <div
                                                style={{
                                                    display: 'inline-block',
                                                    marginRight: '10%'                                         
                                                }}>
                                                <Icon type='setting'/>
                                            </div>
                                            <div
                                                style={{
                                                    display: 'inline-block'
                                                }}>
                                                {'Settings'}
                                            </div>
                                        </Card.Grid>
                                    </a>
                                </Card>
                            </div>)}>
                            <div className={divClassName}>
                                <div className='afsp-account-image-tag'>

                                    {(LOGIN_AS)?'As Admin':'My Account'}
                                </div>
                                <Img
                                    src={usePathname ? `${window.location.pathname}${user}` : `${user}`}
                                    style={{ width: '30px', height: '30px', marginTop: '-40px' }}
                                />
                            </div>
                        </Popover>
                    </Col>
                </Row>
            </div>
        );
    }
}
